import React from 'react';

const AuthContext = React.createContext();
const AlertContext = React.createContext();
const LoadingContext = React.createContext();

export { AuthContext, AlertContext, LoadingContext };
